import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Modal from "@mui/material/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import "./index.sass";
import { makeStyles } from "@material-ui/core/styles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Grid, TextField } from "@material-ui/core";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
    getPackageOffline,
    getCenterInfo
} from "../../actions/OffLineSupportActions";
import { Typography, Box } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: "80%",
        maxWidth: "1200px",
    },
    tableContainer: {
        marginTop: "2rem",
        position: "sticky",
        top: "200px",
    },
    root: {
        flexGrow: 1,
    },
}));
interface centreObject {
    name: string;
    id: number;
    rateListId: number;
    code: string;
}

type ModalProps = {
    openTestModal: boolean;
    setopenTestModal: Function;
    getPackageOffline: Function;
    offlinePkgPrice: any;
    loading: any;
    getCenterInfo: any;
    centerInfo: any;
};

const CommentsModal: React.FC<ModalProps> = ({
    openTestModal,
    setopenTestModal,
    getPackageOffline,
    offlinePkgPrice,
    loading,
    getCenterInfo,
    centerInfo,
}) => {
    const classes = useStyles();
    const timer = useRef<any>(0);
    const history = useHistory();
    const [maxHeight, setMaxHeight] = React.useState<any>(300);
    const [packages, setPackages] = useState<any>([]);
    const [rclShare, setRclShare] = React.useState<number>(0);
    const [accMrp, setAccMrp] = React.useState<number>(0);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [selectedLeads, setSelectedLeads] = useState<any>([]);
    const [showMoreDescription, setShowMoreDescription] = useState<boolean[]>([]);
    const [showMoreSpecimen, setShowMoreSpecimen] = useState<boolean[]>([]);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [viewMore, setViewMore] = useState<boolean[]>([]);
    const [windowWidth, windowHeight] = useWindowSize();
    const [center, setCentre] = useState<any>("");

    const handleClose = () => {
        setopenTestModal(false);
        setPackages([]);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setRclShare(0);
        setAccMrp(0);
    };

    const checkboxStyle = {
        width: "20px",
        height: "20px",
        cursor: "pointer",
        accentColor: "#924A91",
        borderRadius: "4px",
        border: "1px solid #ccc",
        transition: "all 0.3s ease",
    };

    const checkboxStyleMobile = {
        width: "15px",
        height: "15px",
        cursor: "pointer",
        accentColor: "#924A91",
        borderRadius: "4px",
        border: "1px solid #ccc",
        transition: "all 0.3s ease",
    };
    const [storeCentreInfo, setStoreCentreInfo] = useState<centreObject>({
        name: "",
        id: 0,
        rateListId: 0,
        code: "",
    });



    const checkedLead = (event: any, packageId: number) => {
        if (selectedLeads?.length < 10) {
            !event.target.checked
                ? setSelectedLeads(
                    selectedLeads.filter((lead: any) => lead !== packageId)
                )
                : setSelectedLeads((prev: any) => [...prev, packageId]);
        } else {
            return false;
        }
    };
    useEffect(() => {
        let tempCentreInfo: centreObject = {
            name: "",
            id: 0,
            rateListId: 0,
            code: "",
        };
        if (centerInfo?.results?.length > 0 && centerInfo?.results) {
            tempCentreInfo.name = centerInfo?.results[0]?.name;
            tempCentreInfo.id = centerInfo?.results[0]?.id;
            tempCentreInfo.rateListId = centerInfo?.results[0]?.ratelist[0]?.id;
            tempCentreInfo.code = centerInfo?.results[0]?.center_code;
        }
        setStoreCentreInfo(tempCentreInfo);
    }, [centerInfo]);
    const [totalShare, setTotalShare] = useState<number>(0);
    useEffect(() => {
        if (packages.length > 0) {
            var total: any = 0,
                totalMrp: number = 0;
            packages.map((val: any) => {
                total = val?.rcl_share + total;
                totalMrp = val?.package_lab_prices + totalMrp;
            });
            setRclShare(total);
            setAccMrp(totalMrp);
        }
    }, [packages]);

    useEffect(() => {
        if (packages.length > 0) {
            var total: any = 0;
            var myShare: number = 0;
            packages.map((val: any) => {
                myShare =
                    Math.abs(
                        Number(val?.package_lab_prices?.toFixed(2)) -
                        Number(val?.rcl_share?.toFixed(2))
                    ) + myShare;
            });
            setTotalShare(myShare);
        }
    }, [packages]);

    useEffect(() => {
        if (openTestModal && storeCentreInfo.rateListId) {
            getPackageOffline(storeCentreInfo.id, "", storeCentreInfo.code);
        }
    }, [storeCentreInfo.rateListId]);

    const handleClear = () => {
        setPackages([]);
        setAutocompleteKey((prevKey) => prevKey + 1);
        setRclShare(0);
        setAccMrp(0);
        setTotalShare(0);
        setSelectedLeads([]);
        setIsCheckboxChecked(false);
    };

    const handleGoToBooking = () => {
        const updatedPackages = packages.filter((val: any) =>
            selectedLeads.includes(val.id)
        );

        history.push({
            pathname: "/dashboard/os/ccBooking_index_four",
            state: {
                packages: updatedPackages,
            },
        });
    };
    useEffect(() => {
        if (packages?.length === 0) {
            setRclShare(0);
            setAccMrp(0);
            setTotalShare(0);
        }
    }, [packages]);

    useEffect(() => {
        // Initialize showMore states with the correct structure based on the packages
        setShowMoreDescription(packages.map(() => false));
        setShowMoreSpecimen(packages.map(() => false));
        setViewMore(packages.map(() => false));
    }, [packages]);

    const handleShowMoreToggle = (
        index: number,
        type: "description" | "specimen"
    ) => {
        if (type === "description") {
            const updatedShowMore = [...showMoreDescription];
            updatedShowMore[index] = !updatedShowMore[index];
            setShowMoreDescription(updatedShowMore);
        } else if (type === "specimen") {
            const updatedShowMore = [...showMoreSpecimen];
            updatedShowMore[index] = !updatedShowMore[index];
            setShowMoreSpecimen(updatedShowMore);
        }
    };
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openTestModal}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: windowWidth > 450 ? "50%" : "42%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        borderRadius: 5,
                        overflow: "auto",
                        maxHeight: windowWidth > 450 ? "100%" : "90vw",
                        width: windowWidth > 450 ? "80vw" : "90vw",
                        maxWidth: "1200px",
                        padding: "10px",
                    }}
                >
                    <HighlightOffIcon
                        style={{
                            display: "inline-block",
                            right: "2%",
                            position: "absolute",
                            height: "30px",
                            width: "30px",
                        }}
                        onClick={handleClose}
                    />
                    <div>
                        <h5
                            style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                marginBottom: "10px",
                            }}
                        >
                            Estimate Test
                        </h5>
                        <div className={classes.root}>
                            <Grid container spacing={2}>
                                <form style={{ width: "100%" }}>
                                    <Grid
                                        container
                                        spacing={2}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-evenly",
                                            alignItems: "center",
                                            paddingLeft: "10px",
                                        }}
                                    >
                                        <Grid item xs={12} sm={4} md={2}>
                                            <Autocomplete
                                                id="center"
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                                                        setCentre(obj.id);
                                                    }
                                                }}
                                                freeSolo
                                                blurOnSelect
                                                options={centerInfo?.results || []}
                                                disableCloseOnSelect
                                                getOptionLabel={(option: any) =>
                                                    (option?.display_name === null
                                                        ? option?.name
                                                        : option?.display_name) +
                                                    "(" +
                                                    option?.center_code +
                                                    ")"
                                                }
                                                loading={loading}
                                                onInputChange={(event, newInputValue) => {
                                                    clearTimeout(timer.current);
                                                    timer.current = setTimeout(() => {
                                                        getCenterInfo(`?name_or_code=${newInputValue}`);
                                                    }, 1000);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Centre"
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        className="input"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                key={autocompleteKey}
                                                id="customerPackage"
                                                loading={loading}
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        let packs: any = [];
                                                        newValue.map((val: any) => {
                                                            let obj = JSON.parse(
                                                                JSON.stringify(val, null, " ")
                                                            );
                                                            packs.push(obj);
                                                        });
                                                        setPackages(packs);
                                                    }
                                                }}
                                                multiple
                                                disableClearable
                                                options={offlinePkgPrice?.results || []}
                                                limitTags={0}
                                                disabled={offlinePkgPrice?.results && offlinePkgPrice?.results?.length === 0}
                                                disableCloseOnSelect
                                                onInputChange={(event, newInputValue) => {
                                                    clearTimeout(timer.current);
                                                    timer.current = setTimeout(() => {
                                                        getPackageOffline(
                                                            storeCentreInfo.id,
                                                            newInputValue,
                                                            storeCentreInfo.code
                                                        );
                                                    }, 1000);
                                                }}
                                                getOptionLabel={(option: any) =>
                                                    option?.name + "(" + option?.code + ")"
                                                }
                                                renderOption={(option: any) => {
                                                    return (
                                                        <Box
                                                            p={2}
                                                            sx={{
                                                                border: "1px solid #e0e0e0",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#f9f9f9",
                                                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
                                                                transition: "box-shadow 0.3s",
                                                                "&:hover": {
                                                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.16)",
                                                                },
                                                                maxWidth: "400px",
                                                                margin: "10px 0",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="subtitle1"
                                                                component="div"
                                                                sx={{ fontWeight: "bold" }}
                                                            >
                                                                {option.name && option.package_lab_prices
                                                                    ? `${option.name} ${option.code} `
                                                                    : `${option.name} ${option.code}`}
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                component="div"
                                                                sx={{ color: "#757575", mt: 1 }}
                                                            >
                                                                <b style={{ color: "black" }}>
                                                                    Offline prices: {option.package_lab_prices}
                                                                </b>
                                                            </Typography>
                                                            <Typography
                                                                variant="body2"
                                                                component="div"
                                                                sx={{ color: "#757575", mt: 0.5 }}
                                                            >
                                                                {option.package_online_price && (
                                                                    <b style={{ color: "black" }}>
                                                                        Online prices: {option.package_online_price}
                                                                    </b>
                                                                )}
                                                            </Typography>
                                                        </Box>
                                                    );
                                                }}
                                                getOptionDisabled={(option: any) => {
                                                    const packID = packages.map((pack: any) => pack.code);
                                                    return packID.includes(option.code);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="input"
                                                        placeholder="Search & Select Test Name/Code"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={5} sm={2} md={2}>
                                            <Button
                                                style={{
                                                    height: windowWidth > 450 ? "44px" : "38px",
                                                    fontWeight: "600",
                                                    fontSize: windowWidth > 450 ? "1.2rem" : "1rem",
                                                    marginLeft: windowWidth > 450 ? "20px" : "0",
                                                }}
                                                className="input"
                                                variant="contained"
                                                color="secondary"
                                                fullWidth
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                        <Grid item xs={5} sm={2} md={2}>
                                            <Button
                                                disabled={selectedLeads.length === 0}
                                                style={{
                                                    height: windowWidth > 450 ? "44px" : "45px",
                                                    fontWeight: "600",
                                                    marginLeft: windowWidth > 450 ? "20px" : "0",
                                                    background:
                                                        selectedLeads.length === 0
                                                            ? "grey"
                                                            : "rgb(156, 39, 176)",
                                                    color: "white",
                                                    fontSize: windowWidth > 450 ? "15px" : "8px",
                                                }}
                                                className="input"
                                                variant="contained"
                                                fullWidth
                                                onClick={handleGoToBooking}
                                            >
                                                Create Booking
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>
                        </div>
                        <div
                            className={classes.tableContainer}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            {windowWidth > 450 ? (
                                <Grid container>
                                    <div className="price-details-new-booking">
                                        <table style={{ width: "100%", margin: "0" }}>
                                            <thead>
                                                <tr>
                                                    <td className="cell" align="center">
                                                        <span>Select</span>
                                                        <br />
                                                        <input
                                                            type="checkbox"
                                                            className="input"
                                                            name="selectall"
                                                            style={checkboxStyle}
                                                            id="selectall"
                                                            checked={isCheckboxChecked}
                                                            onChange={(e) => {
                                                                setIsCheckboxChecked(e.target.checked);
                                                                if (packages?.length > 0) {
                                                                    e.target.checked
                                                                        ? setSelectedLeads(
                                                                            packages?.length > 0 &&
                                                                            packages?.map(
                                                                                (lead: any, index: number) => {
                                                                                    if (index < 100) {
                                                                                        return lead.id && lead.id;
                                                                                    }
                                                                                }
                                                                            )
                                                                        )
                                                                        : setSelectedLeads([]);
                                                                } else {
                                                                    setIsCheckboxChecked(false);
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                    {/* <td className="cell" align="center">
                           Test code
                         </td> */}
                                                    <td
                                                        className="cell"
                                                        align="center"
                                                        style={{ width: "250px" }}
                                                    >
                                                        Test Name
                                                    </td>
                                                    <td
                                                        className="cell"
                                                        align="center"
                                                        style={{ width: "250px" }}
                                                    >
                                                        Sample Type
                                                    </td>
                                                    <td
                                                        className="cell"
                                                        align="center"
                                                        style={{ width: "100px" }}
                                                    >
                                                        MRP
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Wallet Amount
                                                    </td>
                                                    <td className="cell" align="center">
                                                        My Share
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Online Price
                                                    </td>

                                                    <td className="cell" align="center">
                                                        TAT
                                                    </td>
                                                    <td className="cell" align="center">
                                                        Sample Report
                                                    </td>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {packages &&
                                                    packages.length > 0 &&
                                                    packages.map((packageItem: any, index: any) => (
                                                        <tr key={index}>
                                                            <td className="cell" align="center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="input"
                                                                    name="selectall"
                                                                    style={checkboxStyle}
                                                                    id="selectall"
                                                                    checked={selectedLeads.some(
                                                                        (lead: any) => lead === packageItem.id
                                                                    )}
                                                                    onChange={(e: any) =>
                                                                        checkedLead(e, packageItem.id)
                                                                    }
                                                                />
                                                            </td>
                                                            <td
                                                                className="cell"
                                                                align="left"
                                                                style={{ width: "250px" }}
                                                            >
                                                                <span style={{ fontSize: "1rem" }}>
                                                                    {" "}
                                                                    {packageItem?.code + "-" + packageItem?.name}
                                                                </span>
                                                                <br />
                                                                {packageItem?.description ? (
                                                                    packageItem.description.length > 25 &&
                                                                        !showMoreDescription[index] ? (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    color: "#9d2a2a",
                                                                                    fontSize: ".9rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                            >
                                                                                ({packageItem.description.slice(0, 26)})
                                                                            </span>

                                                                            <span
                                                                                style={{
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                    fontStyle: "italic",
                                                                                    fontSize: "1.1rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleShowMoreToggle(
                                                                                        index,
                                                                                        "description"
                                                                                    )
                                                                                }
                                                                            >
                                                                                ...more
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    color: "#9d2a2a",
                                                                                    fontSize: ".9rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                            >
                                                                                ( {packageItem.description})
                                                                            </span>
                                                                            {packageItem.description.length > 25 && (
                                                                                <span
                                                                                    style={{
                                                                                        color: "blue",
                                                                                        cursor: "pointer",
                                                                                        fontStyle: "italic",
                                                                                        fontSize: "1.1rem",
                                                                                        fontWeight: "500",
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        handleShowMoreToggle(
                                                                                            index,
                                                                                            "description"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    ...less
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                            <td
                                                                className="cell"
                                                                align="left"
                                                                style={{ width: "250px" }}
                                                            >
                                                                {packageItem?.specimen ? (
                                                                    packageItem.specimen.length > 15 &&
                                                                        !showMoreSpecimen[index] ? (
                                                                        <>
                                                                            <span style={{ fontSize: "1rem" }}>
                                                                                {" "}
                                                                                {packageItem.specimen.slice(0, 25)}{" "}
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                    fontStyle: "italic",
                                                                                    fontSize: "1.1rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleShowMoreToggle(
                                                                                        index,
                                                                                        "specimen"
                                                                                    )
                                                                                }
                                                                            >
                                                                                ...more
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span style={{ fontSize: "1rem" }}>
                                                                                {" "}
                                                                                {packageItem.specimen}{" "}
                                                                            </span>
                                                                            {packageItem.specimen.length > 25 && (
                                                                                <span
                                                                                    style={{
                                                                                        color: "blue",
                                                                                        cursor: "pointer",
                                                                                        fontStyle: "italic",
                                                                                        fontSize: "1.1rem",
                                                                                        fontWeight: "500",
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        handleShowMoreToggle(
                                                                                            index,
                                                                                            "specimen"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    ...less
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>

                                                            <td
                                                                className="cell"
                                                                align="center"
                                                                style={{ width: "100px" }}
                                                            >
                                                                {Number(packageItem?.package_lab_prices)}
                                                            </td>
                                                            <td className="cell" align="center">
                                                                {Number(packageItem?.rcl_share)}
                                                            </td>
                                                            <td className="cell" align="center">
                                                                {Math.abs(
                                                                    Number(packageItem?.package_lab_prices) -
                                                                    Number(packageItem?.rcl_share)
                                                                )}
                                                            </td>

                                                            <td className="cell" align="center">
                                                                {Number(packageItem?.package_online_price)}
                                                            </td>
                                                            <td className="cell" align="center">
                                                                {packageItem?.package_city_tat}
                                                            </td>
                                                            <td className="cell" align="center">
                                                                <div
                                                                    style={{
                                                                        marginTop: "20px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {packageItem?.sample_report ? (
                                                                        <a
                                                                            href={packageItem?.sample_report}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{
                                                                                display: "block",
                                                                                textDecoration: "none",
                                                                                padding: "10px",
                                                                                borderRadius: "5px",
                                                                                textAlign: "center",
                                                                                fontWeight: "500",
                                                                                fontSize: "1rem",
                                                                            }}
                                                                        >
                                                                            Click To Download!
                                                                        </a>
                                                                    ) : (
                                                                        <span style={{ color: "red" }}>
                                                                            No Report
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                <tr>
                                                    <td className="cell" align="center" />
                                                    <td className="cell" align="center" />
                                                    <td className="cell" align="left">
                                                        Total
                                                    </td>
                                                    <td className="cell" align="center">
                                                        ₹ {accMrp}
                                                    </td>
                                                    <td className="cell" align="center">
                                                        ₹ {Number(rclShare)}
                                                    </td>
                                                    <td className="cell" align="center">
                                                        ₹ {totalShare}
                                                    </td>

                                                    <td className="cell" align="left" colSpan={2}>
                                                        <b> Total My Share :</b>
                                                    </td>
                                                    <td className="cell" align="center">
                                                        ₹ {Math.abs(Number(accMrp) - Number(rclShare))}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>
                            ) : (
                                <Grid container spacing={2}>
                                    <div
                                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "30px" }}
                                    >
                                        <div style={{ marginLeft: "7px" }}>
                                            Select All:
                                            <input
                                                type="checkbox"
                                                className="input"
                                                name="selectall"
                                                style={checkboxStyleMobile}
                                                id="selectall"
                                                checked={isCheckboxChecked}
                                                onChange={(e) => {
                                                    setIsCheckboxChecked(e.target.checked);
                                                    if (packages?.length > 0) {
                                                        e.target.checked
                                                            ? setSelectedLeads(
                                                                packages?.length > 0 &&
                                                                packages?.map(
                                                                    (lead: any, index: number) => {
                                                                        if (index < 100) {
                                                                            return lead.id && lead.id;
                                                                        }
                                                                    }
                                                                )
                                                            )
                                                            : setSelectedLeads([]);
                                                    } else {
                                                        setIsCheckboxChecked(false);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <TableContainer>
                                                <Table
                                                    sx={{ minWidth: 100, border: "1px solid rgba(224, 224, 224, 1)" }}
                                                    size="small"
                                                    aria-label="simple table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">Total Amount</TableCell>
                                                            <TableCell align="center">Wallet Amount</TableCell>
                                                            <TableCell align="center">My Share</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="center"> ₹ {accMrp}</TableCell>
                                                            <TableCell align="center"> ₹ {Number(rclShare)}</TableCell>
                                                            <TableCell align="center"> ₹ {totalShare}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                    {packages &&
                                        packages.length > 0 &&
                                        packages.map((packageItem: any, index: any) => (
                                            <div style={{ margin: "5px 5px", }}>
                                                <Card
                                                    sx={{
                                                        minWidth: 275,
                                                        backgroundColor: "#4c69ae",
                                                        color: "white",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <CardContent>
                                                        <div>
                                                            <span>
                                                                Test Name:
                                                                {packageItem?.code + "-" + packageItem?.name}
                                                            </span>
                                                            <span>
                                                                {packageItem?.description ? (
                                                                    packageItem.description.length > 25 &&
                                                                        !showMoreDescription[index] ? (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    color: "#9d2a2a",
                                                                                    fontSize: ".9rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                            >
                                                                                ({packageItem.description.slice(0, 26)})
                                                                            </span>

                                                                            <span
                                                                                style={{
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                    fontStyle: "italic",
                                                                                    fontSize: "1.1rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleShowMoreToggle(
                                                                                        index,
                                                                                        "description"
                                                                                    )
                                                                                }
                                                                            >
                                                                                ...more
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    color: "#9d2a2a",
                                                                                    fontSize: ".9rem",
                                                                                    fontWeight: "500",
                                                                                }}
                                                                            >
                                                                                ( {packageItem.description})
                                                                            </span>
                                                                            {packageItem.description.length > 25 && (
                                                                                <span
                                                                                    style={{
                                                                                        color: "blue",
                                                                                        cursor: "pointer",
                                                                                        fontStyle: "italic",
                                                                                        fontSize: "1.1rem",
                                                                                        fontWeight: "500",
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        handleShowMoreToggle(
                                                                                            index,
                                                                                            "description"
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    ...less
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </span>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                }}
                                                            >
                                                                <p>
                                                                    MRP: {Number(packageItem?.package_lab_prices)}
                                                                </p>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input"
                                                                    name="selectall"
                                                                    style={checkboxStyleMobile}
                                                                    id="selectall"
                                                                    checked={selectedLeads.some(
                                                                        (lead: any) => lead === packageItem.id
                                                                    )}
                                                                    onChange={(e: any) =>
                                                                        checkedLead(e, packageItem.id)
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            onClick={() => {
                                                                setViewMore((prevState) => {
                                                                    const newState = [...prevState];
                                                                    newState[index] = !newState[index];
                                                                    return newState;
                                                                });
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    border: "1px sold black",
                                                                    borderRadius: "5px",
                                                                    color: "black",
                                                                    padding: "3px 5px",
                                                                }}
                                                            >
                                                                {viewMore[index] ? "view less" : "view more"}
                                                            </span>
                                                        </div>
                                                        {viewMore[index] && (
                                                            <div>
                                                                {" "}
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                >
                                                                    <p>
                                                                        Sample Type:{" "}
                                                                        {packageItem?.specimen ? (
                                                                            packageItem.specimen.length > 15 &&
                                                                                !showMoreSpecimen[index] ? (
                                                                                <>
                                                                                    <span style={{ fontSize: "1rem" }}>
                                                                                        {" "}
                                                                                        {packageItem.specimen.slice(
                                                                                            0,
                                                                                            25
                                                                                        )}{" "}
                                                                                    </span>
                                                                                    <span
                                                                                        style={{
                                                                                            color: "blue",
                                                                                            cursor: "pointer",
                                                                                            fontStyle: "italic",
                                                                                            fontSize: "1.1rem",
                                                                                            fontWeight: "500",
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            handleShowMoreToggle(
                                                                                                index,
                                                                                                "specimen"
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        ...more
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <span style={{ fontSize: "1rem" }}>
                                                                                        {" "}
                                                                                        {packageItem.specimen}{" "}
                                                                                    </span>
                                                                                    {packageItem.specimen.length > 25 && (
                                                                                        <span
                                                                                            style={{
                                                                                                color: "blue",
                                                                                                cursor: "pointer",
                                                                                                fontStyle: "italic",
                                                                                                fontSize: "1.1rem",
                                                                                                fontWeight: "500",
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                handleShowMoreToggle(
                                                                                                    index,
                                                                                                    "specimen"
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            ...less
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </p>
                                                                    <p>
                                                                        Wallet Amount:{" "}
                                                                        {Number(packageItem?.rcl_share)}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                >
                                                                    <p>
                                                                        My Share:
                                                                        {Math.abs(
                                                                            Number(packageItem?.package_lab_prices) -
                                                                            Number(packageItem?.rcl_share)
                                                                        )}
                                                                    </p>
                                                                    <p>
                                                                        Online Price:{" "}
                                                                        {Number(packageItem?.package_online_price)}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                >
                                                                    <p>TAT: {packageItem?.package_city_tat}</p>
                                                                    <p>
                                                                        Sample Report:
                                                                        {packageItem?.sample_report ? (
                                                                            <a
                                                                                href={packageItem?.sample_report}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{
                                                                                    display: "block",
                                                                                    textDecoration: "none",
                                                                                    padding: "10px",
                                                                                    borderRadius: "5px",
                                                                                    textAlign: "center",
                                                                                    fontWeight: "500",
                                                                                    fontSize: "1rem",
                                                                                }}
                                                                            >
                                                                                Click
                                                                            </a>
                                                                        ) : (
                                                                            <span style={{ color: "red" }}>
                                                                                No Report
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        ))}
                                </Grid>
                            )}
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    centerInfo: state.OffLineSupporteReducer.centerInfo,
    offlinePkgPrice: state.OffLineSupporteReducer.offlinePkgPrice,
    loading: state.OffLineSupporteReducer.loading,
});

export default connect(mapStateToProps, {
    getPackageOffline,
    getCenterInfo
})(CommentsModal);
